
/**
 * Initialize Onboarding
 */
function Onboarding() {
  const buttonSubmit = document.querySelector('[data-onboarding-submit]');
  const buttonAddEmail = document.querySelector('[data-onboarding-button-add-email]');
  const radioButtons = document.querySelectorAll('[data-onboarding-radio-button]');
  const buttonsRemoveEmail = document.querySelectorAll('[data-remove-email]');
  const inputPassword = document.querySelector('#password');

  if (document.contains(buttonSubmit)) {
    buttonSubmit.addEventListener('click', handlerClickButttonSubmitForm)
  }

  if (document.contains(buttonAddEmail)) {
    buttonAddEmail.addEventListener('click', handlerClickButtonAddEmail)
  }

  if (document.contains(inputPassword)) {
    setupButtonShowPassword(inputPassword);
  }

  if (buttonsRemoveEmail.length) {
    buttonsRemoveEmail.forEach((currentButton) => {
      currentButton.addEventListener('click',  handlerClickButtonRemoveEmail);
    });
  }

  if (radioButtons.length) {
    radioButtons.forEach((currentButton) => {
      applyUserOldChoiceCustomRadioButton(currentButton);

      currentButton.addEventListener('click', () => {
        handlerCheckRadioButton(currentButton, radioButtons);
      });
    });
  }
}

/**
 * Handle click button to submit form
 *
 * @param {Event} event
 */
function handlerClickButttonSubmitForm(event) {
  const idForm = event.target.dataset.onboardingForm;
  const form = document.querySelector(`#${idForm}`);

  if (!$(form).valid()) {
    return false;
  }

  const inputPassword = form.querySelector('#password');
  if (document.contains(inputPassword)) {
    if (inputPassword.type !== 'password') {
      inputPassword.setAttribute('type', 'password');
    }
  }

  form.submit();
}

/**
 *
 * @param {Event} event
 */
function handlerClickButtonAddEmail(event) {
  const containerInputEmails = document.querySelector('[data-content-inputs-email]');
  const indexInput = getNextIndexInputEmail();

  const divHolderInputEmail = document.createElement('div');
  divHolderInputEmail.className = 'form__holder-input-email';

  const divFormGroup = document.createElement('div');
  divFormGroup.className = 'form-group';

  // Adiciona as divs no container
  divHolderInputEmail.appendChild(divFormGroup);
  containerInputEmails.appendChild(divHolderInputEmail);

  // Cria o botão de remover
  const buttonRemoveEmail = document.createElement('button');
  buttonRemoveEmail.className = 'fa fa-times remove-email';
  buttonRemoveEmail.addEventListener('click',  handlerClickButtonRemoveEmail);

  divHolderInputEmail.appendChild(buttonRemoveEmail);

  // Cria o input de e-mail
  const inputEmail = document.createElement('input');
  inputEmail.type = 'text';
  inputEmail.placeholder = 'email@suaempresa.com...';
  inputEmail.className = 'form-control';
  inputEmail.name = `convites[${indexInput}]`;
  inputEmail.id = `convites-${indexInput}`;

  inputEmail.dataset.canBeNull = true;
  inputEmail.dataset.ruleEmailRegistred = true;
  inputEmail.dataset.indexInputEmail = indexInput;

  divFormGroup.appendChild(inputEmail);

  // Adiciona a regra de e-mail no input criado
  const formId = $(inputEmail).closest('form').attr('id');
  $(`#${formId}`).validate({ onfocusout: false });
  $(`#${inputEmail.id}`).rules('add', 'validEmailRegistred');

  containerInputEmails.scrollTop = containerInputEmails.scrollHeight;
}

/**
 * Evento de click para o botão de exibição de senha
 *
 * @param {Element} inputPassword
 */
function setupButtonShowPassword(inputPassword) {
  const buttonShowPassword = inputPassword
    .closest('.input-group')
    .querySelector('.input-group-addon');

  const iconButtonPassword = buttonShowPassword.querySelector('.fa');

  buttonShowPassword.addEventListener('click', function() {
    const inputType = inputPassword.type;
    const newInputType = (inputType === 'password')
      ? 'text'
      : 'password';

    inputPassword.setAttribute('type', newInputType);

    if (newInputType === 'text') {
      iconButtonPassword.classList.remove('fa-eye');
      iconButtonPassword.classList.add('fa-eye-slash');

      return;
    }

    iconButtonPassword.classList.remove('fa-eye-slash');
    iconButtonPassword.classList.add('fa-eye');
  });
}

/**
 * Evento de click dos radio buttons
 *
 * @param {Element} radioButtonClicked
 * @param {Array[Elements]} radioButtons
 */
function handlerCheckRadioButton(radioButtonClicked, radioButtons) {
  const classChecked = radioButtonClicked.dataset.onboardingRadioButton;

  radioButtons.forEach((currentRadio) => {
    currentRadio.classList.remove(classChecked);
  });
  radioButtonClicked.classList.add(classChecked);
}

/**
 * Aplicar a seleção do radio button que havia sido escolhido
 * pelo usuário em algum outro momento
 * (isto irá se aplicar quando o usuário clicar em voltar alguma das etapas)
 *
 * @param {Element} currentButton
 */
function applyUserOldChoiceCustomRadioButton(currentButton) {
  const inputRadio = currentButton.querySelector('[type="radio"]');
  const classChecked = currentButton.dataset.onboardingRadioButton;
  const oldUserAnswer = inputRadio.dataset.userAnswer;
  const inputValue = inputRadio.value;

  if (inputValue === oldUserAnswer) {
    inputRadio.checked = true;
    currentButton.classList.add(classChecked);
  }
}

/**
 * Remover a input de email com erro
 *
 * @param {Event} event
 */
function handlerClickButtonRemoveEmail(event) {
  const button = event.target;
  const holderInputEmail = button.closest('.form__holder-input-email');
  holderInputEmail.remove();
}

/**
 * Obter o index da última input que foi adicionada na tela
 */
function getNextIndexInputEmail() {
  const inputEmails = document.querySelectorAll('[data-index-input-email]');
  let lastIndex = 0;
  inputEmails.forEach((currentInput) => {
    lastIndex = currentInput.dataset.indexInputEmail;
  });

  lastIndex++;
  return lastIndex;
}
module.exports = {
  init: Onboarding,
  url: /^\/onboarding\//
};
